import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _skills = [];
let _levelOptions= [];
let _typeOptions= [];
let _groupOptions= [];
let _fetchedAll = false;

const sanitise = ({id, trainer, ...rest}) => ({
    id: Number(id),
    trainer: Number(trainer), // TODO: should be bool, but need to adjust code
    ...rest
});


let SkillStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _skills.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _skills.find(function(e) { return e !== undefined && e.id == id; } );
    },
    add: function(entity) {
        let index = _skills.findIndex(function(e) { return e !== undefined && e.id == entity.id; } );
        if (0 <= index) {
            _skills[index] = entity;
        } else {
            _skills.push(entity);
        }
    },
    delete: function(data) {
        if (data.id !== undefined) {
            var index = _skills.findIndex(function(e) { return e !== undefined && e.id == data.id; });
            if (0 <= index) {
                if (!!data.deleted) {
                    delete _skills[index];
                } else {
                    _skills[index].loading = false;
                }
            }
        }
    },
    getLevelOptions: function() {
        return _levelOptions;
    },
    getTypeOptions: function() {
        return _typeOptions;
    },
    getGroupOptions: function() {
        return _groupOptions;
    },
    fetchedAll: () => (_fetchedAll)

});

SkillStore.dispatchToken = CentricDispatcher.register(function(action) {
    
    switch(action.type) {

        case ActionTypes.SKILL_LIST:
            action.data.forEach(SkillStore.add);
            _fetchedAll = action.data.length === 0;
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_LIST_ERROR:
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_INFO:
            SkillStore.add(action.data);
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_INFO_ERROR:
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_SAVE:
            SkillStore.add(action.data);
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_UPDATE:
            SkillStore.add(action.data);
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_DELETE:
            SkillStore.delete(action.data);
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_LEVEL_OPTION_LIST:
            _levelOptions = action.data;
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_TYPE_OPTION_LIST:
            _typeOptions = action.data;
            SkillStore.emitChange();
            break;

        case ActionTypes.SKILL_GROUP_OPTION_LIST:
            _groupOptions = action.data;
            SkillStore.emitChange();
            break;

        default:
            break;  
    }
   
});

export default SkillStore;
